import { SET_SIDER, SET_USER_INFO, SET_BREADCRUMB, SET_ORGLIST, SET_CARDTYPE, SET_PAYCHANNEL, SET_SYSNOTICE } from './App.action'
import { ReactComponent as Overview } from './assets/overview.svg'
import { ReactComponent as Trade } from './assets/trade.svg'
import { ReactComponent as Canteen } from './assets/canteen.svg'
import { ReactComponent as Merchant } from './assets/merchant.svg'
import { ReactComponent as Statement } from './assets/statement.svg'
import { ReactComponent as Funds } from './assets/funds.svg'

import { ReactComponent as Shool } from './assets/school.svg'
import { ReactComponent as Agent } from './assets/agent.svg'
import { ReactComponent as Channel } from './assets/channel.svg'
import { ReactComponent as Device } from './assets/device.svg'
import { ReactComponent as PaySet } from './assets/paySet.svg'
import { ReactComponent as Account } from './assets/account.svg'
import { ReactComponent as Compare } from './assets/compare.svg'
import { ReactComponent as Coop } from './assets/coop.svg'
import { ReactComponent as News } from './assets/news.svg'
import { ReactComponent as Weak } from './assets/weak.svg'
import { ReactComponent as ReadMe } from './assets/readme.svg'

const initState = {
    userInfo: {},
    orgList: [],
    sider: {
        width: 256,
        collapsedWidth: 64,
        collapsed: window.location.href.includes('localhost') ? true : false
    },
    cardType: [],
    paychannel: [],
    breadcrumb: [],
    menuIconList: {
      overview : Overview,
      trade : Trade,
      canteen : Canteen,
      merchant : Merchant,
      statement : Statement,
      funds : Funds,
      shool : Shool,
      agent : Agent,
      channel : Channel,
      device : Device,
      payset : PaySet,
      account : Account,
      compare : Compare,
      coop : Coop,
      news : News,
      weak : Weak,
      readme : ReadMe,
    },
    menuList: [{
        key: '/overview',
        value: '概览',
        visible: ['Admin', 'SystemAdmin']
    }, {
        key: '/school',
        value: '学校管理',
        visible: ['Agent', 'SystemAdmin']
    }, {
        key: '/agent',
        value: '代理商管理',
        visible: ['SystemAdmin']
    }, {
        key: '/channel',
        value: '渠道管理',
        visible: ['SystemAdmin'],
        subList: [{
            key: '/channel/index',
            value: '渠道管理',
            visible: ['SystemAdmin'],
        }, {
            key: '/channel/implement',
            value: '落地实施人员管理',
            visible: ['SystemAdmin']
        }, {
            key: '/channel/smerchant',
            value: '超级商户管理',
            visible: ['SystemAdmin']
        }]
    }, {
        key: '/device',
        value: '机具管理',
        visible: ['SystemAdmin'],
        subList: [{
            key: '/device/index',
            value: '机具厂商/型号管理',
            visible: ['SystemAdmin'],
        }, {
            key: '/device/receipt',
            value: '收货管理',
            visible: ['SystemAdmin']
        }, {
            key: '/device/deliver',
            value: '发货管理',
            visible: ['SystemAdmin']
        },]
    }, {
        key: '/paySet', //aliuser
        value: '账户管理',
        visible: ['SystemAdmin']
    }, {
        key: '/trade',
        value: '交易流水',
        visible: ['Admin', 'SystemAdmin', 'Merchant', 'SystemMerchant']
    }, {
        key: '/canteen',
        value: '食堂管理',
        visible: ['Admin', 'SystemAdmin', 'Merchant']
    }, {
        key: '/canbu',
        value: '高级餐补',
        visible: ['Admin', 'SystemAdmin', 'Merchant'],
        subList: [{
            key: '/canbu/list',
            value: '规则设置',
            visible: ['Admin', 'SystemAdmin', 'Merchant']
        }]
    }, {
        key: '/weak',
        value: '弱网支付管理',
        visible: ['Admin', 'SystemAdmin', 'Merchant'],
        subList: [{
            key: '/weak/list',
            value: '订单管理',
            visible: ['Admin', 'SystemAdmin', 'Merchant']
        }, {
            key: '/weak/device',
            value: '机具管理',
            visible: ['Admin', 'SystemAdmin', 'Merchant']
        }, {
            key: '/weak/blacklist',
            value: '黑名单管理',
            visible: ['Admin', 'SystemAdmin', 'Merchant']
        }]
    }, {
        key: '/campus',
        value: '校区管理',
        visible: ['Admin', 'SystemAdmin']
    }, {
        key: '/merchant',
        value: '商户管理',
        visible: ['Admin', 'SystemAdmin']
    }, {
        key: '/account',
        value: '账号管理',
        visible: ['SystemAdmin']
    }, {
        key: '/statement',
        value: '对账单下载',
        visible: ['Admin', 'SystemAdmin', 'Merchant']
    }, {
        key: '/funds',
        value: '财务报表',
        visible: ['Admin', 'SystemAdmin', 'Merchant', 'SystemMerchant'],
        subList: [{
          key: '/funds',
          hide: true,
          manage: false,
          value: '原报表',
          visible: ['Admin', 'SystemAdmin', 'Merchant', 'SystemMerchant'],
        }, {
          key: '/fundsdown',
          manage: false,
          value: '标准报表',
          visible: ['Admin', 'SystemAdmin', 'Merchant', 'SystemMerchant'],
        }, {
          key: '/fundscustom',
          manage: false,
          value: '自定义报表',
          visible: ['Admin', 'SystemAdmin', 'Merchant', 'SystemMerchant'],
        }]
    }, {
        key: '/wallet',
        value: '校园钱包管理',
        visible: ['Admin', 'SystemAdmin', 'Merchant', 'SystemMerchant'],
        subList: [{
            key: '/wallet/accounts',
            manage: false,
            value: '钱包账户',
            visible: ['Admin', 'SystemAdmin', 'Merchant', 'SystemMerchant'],
        }, {
            key: '/wallet/recharge',
            manage: false,
            value: '校园钱包充值',
            visible: ['Admin', 'SystemAdmin', 'Merchant', 'SystemMerchant'],
        }, {
            key: '/wallet/balance',
            manage: true,
            value: '商户对账',
            visible: ['Admin', 'SystemAdmin', 'Merchant', 'SystemMerchant'],
        },{
            key: '/wallet/stream',
            manage: true,
            value: '校园钱包流水',
            visible: ['Admin', 'SystemAdmin', 'Merchant', 'SystemMerchant'],
        },{
            key: '/wallet/manage',
            manage: false,
            value: '余额管理',
            visible: ['Admin', 'SystemAdmin', 'Merchant', 'SystemMerchant'],
        },{
            key: '/wallet/overdue',
            manage: false,
            value: '过期金额查询',
            visible: ['Admin', 'SystemAdmin', 'Merchant', 'SystemMerchant'],
        }]
    }, {
        key: '/wxprofitsharing',
        value: '微信对账单管理',
        visible: ['Admin', 'SystemAdmin']
    }, {
        key: '/compare',
        value: '对账管理',
        visible: ['SystemAdmin']
    }, {
        key: '/coop',
        value: '合作审核管理',
        visible: ['SystemAdmin']
    }, {
        key: '/news',
        value: '新闻列表管理',
        visible: ['SystemAdmin']
    }, {
        key: '/app',
        value: '帮助中心',
        visible: ['Admin', 'SystemAdmin']
    }, {
        key: '/readme',
        value: '帮助中心',
        visible: ['Admin', 'SystemAdmin', 'Merchant', 'SystemMerchant']
    }]
};

const appRs = (state = initState, action) => {
    let { type, ...payload } = action
    switch (type) {
        case SET_SIDER:
        case SET_USER_INFO:
        case SET_BREADCRUMB:
        case SET_CARDTYPE:
        case SET_PAYCHANNEL:
        case SET_ORGLIST:
        case SET_SYSNOTICE:
            return Object.assign({}, state, payload)
        default:
            return state
    }
}

export default appRs



// WEBPACK FOOTER //
// ./src/App.reducer.js